/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";

export const SupplierOfferRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["engineering.supplier-offers"]),
    resourceId: zod.string().describe("Opaque composite id encoded as supplierId\/catalogItemId."),
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type SupplierOfferRealtimeChange = zod.input<typeof SupplierOfferRealtimeChange>;
export type SupplierOfferRealtimeChangeOutput = zod.output<typeof SupplierOfferRealtimeChange>;
